import { render, staticRenderFns } from "./_concern_attr.vue?vue&type=template&id=53759647&lang=pug"
import script from "./_concern_attr.vue?vue&type=script&lang=js"
export * from "./_concern_attr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports